import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/shared/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-pill border px-2.5 py-0.5 text-14 font-semibold",
  {
    variants: {
      variant: {
        default: "border-transparent bg-amber text-amber-ink",
        secondary: "border-transparent bg-bg-3 text-chalk",
        outline: "border-line text-chalk-2",
        ok: "border-transparent bg-ok text-ok-ink",
        bad: "border-transparent bg-bad text-white",
        warn: "border-transparent bg-warn text-amber-ink",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
